import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("velvet_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (path) => `${API}/files/${path}`;

export function isBoosted(p) {
  if (!p || !p.boosted) return false;
  if (p.boosted_until && new Date(p.boosted_until) < new Date()) return false;
  return true;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Er ging iets mis. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
